// extracted by mini-css-extract-plugin
module.exports = {"form-button":"styles_form-button__Ta3PA","form-label":"styles_form-label__os7di"};